const RESEND_API_KEY = process.env.REACT_APP_RESEND_API_KEY;

const generateBinanceEmailHTML = (data) => {
  const { amount: rawAmount, currency, fallbackEmail, exploreLink } = data;
  const amount = rawAmount || '0';
  const contactEmail = fallbackEmail || 'support@skyhighntb.com';
  const explorerUrl = exploreLink && exploreLink !== '#' ? exploreLink : `mailto:${contactEmail}`;

  return `<div style="background-color:#efefef">
      <div style="margin:0px auto;max-width:600px">
        <table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="width:100%">
          <tbody>
            <tr>
              <td style="direction:ltr;font-size:0px;padding:0 0 0 0;padding-bottom:0;padding-left:0;padding-right:0;padding-top:0;text-align:center">
                <div style="margin:0px auto;max-width:600px">
                  <table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="width:100%">
                    <tbody>
                      <tr>
                        <td style="direction:ltr;font-size:0px;padding:0 0 0 0;padding-bottom:0;padding-left:0;padding-right:0;padding-top:0;text-align:center">
                          <div style="font-size:0px;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:100%">
                            <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align:top" width="100%">
                              <tbody>
                                <tr>
                                  <td align="center" style="font-size:0px;padding:0 0 0 0;padding-top:0;padding-right:0;padding-bottom:0;padding-left:0;word-break:break-word">
                                    <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="min-width:100%;max-width:100%;width:100px;border-collapse:collapse;border-spacing:0px">
                                      <tbody>
                                        <tr>
                                          <td>
                                            <img height="auto" src="https://ci3.googleusercontent.com/meips/ADKq_NYhjgGN9V6g8u6puyYp_wcUvP43ivhbvfr07_8PjQpdfZWy2H77hNW_cqOkBqgtspBBkJxUkNhWGb34yL5ICY_tQMhlQJxGJDy0FWM0IPwNubmYFpMY01kXuqnS38Y2Epgf4_oJPxqCQ2Fefs3e=s0-d-e1-ft#https://public.bnbstatic.com/image/ufo/20210831/1e00bd49-0695-4eaa-8ab0-6dd89a7087fb.png" style="border:0;display:block;outline:none;text-decoration:none;height:auto;min-width:100%;width:100%;max-width:100%;font-size:13px" width="100" />
                                          </td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div style="background:#ffffff;background-color:#ffffff;margin:0px auto;max-width:600px">
        <table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#ffffff;background-color:#ffffff;width:100%">
          <tbody>
            <tr>
              <td style="direction:ltr;font-size:0px;padding:5px 5px 5px 5px;text-align:center">
                <div style="margin:0px auto;max-width:590px">
                  <table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="width:100%">
                    <tbody>
                      <tr>
                        <td style="direction:ltr;font-size:0px;padding:5px 5px 5px 5px;text-align:center">
                          <div style="font-size:0px;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:100%">
                            <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align:top" width="100%">
                              <tbody>
                                <tr>
                                  <td align="left" style="font-size:0px;padding:5px 5px 10px 5px;word-break:break-word">
                                    <div style="font-family:BinancePlex,Arial,PingFangSC-Regular,'Microsoft YaHei',sans-serif;font-size:20px;font-weight:900;line-height:25px;text-align:left;color:#000000">Deposit Successful</div>
                                  </td>
                                </tr>
                                <tr>
                                  <td align="left" style="background:#ffffff;font-size:0px;padding:5px 5px 5px 5px;word-break:break-word">
                                    <div style="font-family:BinancePlex,Arial,PingFangSC-Regular,'Microsoft YaHei',sans-serif;font-size:14px;line-height:20px;text-align:left;color:#000000">
                                      <div>Your deposit of ${amount} ${currency} is now available in your Binance account. Log in to check your balance.&nbsp;
                                        <span>Read our </span>
                                        <a href="mailto:${contactEmail}" style="text-decoration-line:none;color:#f0b90b">FAQs</a>
                                        <span> if you are running into problems.</span>
                                      </div>
                                    </div>
                                  </td>
                                </tr>
                                <tr>
                                  <td align="left" style="font-size:0px;padding:10px 5px 10px 5px;word-break:break-word">
                                    <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="border-collapse:separate;line-height:100%">
                                      <tbody>
                                        <tr>
                                          <td align="center" bgcolor="#FCD535" role="presentation" style="border:none;border-radius:3px;background:#fcd535" valign="middle">
                                            <a href="${explorerUrl}" style="display:inline-block;background:#fcd535;color:#000000;font-family:BinancePlex,Arial,PingFangSC-Regular,'Microsoft YaHei',sans-serif;font-size:14px;font-weight:900;line-height:15px;margin:0;text-decoration:none;text-transform:none;padding:10px 25px;border-radius:3px">
                                              Visit on explorer
                                            </a>
                                          </td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </td>
                                </tr>
                                <tr>
                                  <td align="left" style="font-size:0px;padding:5px 5px 5px 5px;word-break:break-word">
                                    <div style="font-family:BinancePlex,Arial,PingFangSC-Regular,'Microsoft YaHei',sans-serif;font-size:14px;line-height:20px;text-align:left;color:#000000">
                                      <div>Don't recognize this activity? Please 
                                        <a href="mailto:${contactEmail}" style="color:#f0b90b">reset your password</a> and contact 
                                        <a href="mailto:${contactEmail}" style="color:#f0b90b">customer support</a> immediately.&nbsp;
                                      </div>
                                      <div>
                                        <br>
                                      </div>
                                      
                                    </div>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div style="background:#ffffff;background-color:#ffffff;margin:0px auto;max-width:600px">
        <table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#ffffff;background-color:#ffffff;width:100%">
          <tbody>
            <tr>
              <td style="border:0 none rgb(0,0,0);direction:ltr;font-size:0px;padding:5px 5px 5px 5px;text-align:center">
                <div style="margin:0px auto;max-width:590px">
                  <table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="width:100%">
                    <tbody>
                      <tr>
                        <td style="direction:ltr;font-size:0px;padding:5px 5px 5px 5px;text-align:center">
                          <div style="font-size:0px;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:100%">
                            <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align:top" width="100%">
                              <tbody>
                                <tr>
                                  <td align="center" style="font-size:0px;padding:5px 5px 5px 5px;word-break:break-word">
                                    <p style="border-top:solid 1px #f0b90b;font-size:1px;margin:0px auto;width:100%">
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td align="center" style="font-size:0px;padding:5px 5px 5px 5px;word-break:break-word">
                                    <div style="font-family:BinancePlex,Arial,PingFangSC-Regular,'Microsoft YaHei',sans-serif;font-size:14px;font-weight:900;line-height:20px;text-align:center;color:#f0b90b">
                                      <span>Stay connected!</span>
                                    </div>
                                  </td>
                                </tr>
                                <tr>
                                  <td style="font-size:0px;word-break:break-word">
                                    <div style="font-size:0;line-height:0;text-align:left;display:inline-block;width:100%;direction:ltr">
                                      <div style="font-size:0px;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:100%">
                                        <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align:top" width="100%">
                                          <tbody>
                                            <tr>
                                              <td align="center" style="font-size:0px;padding:5px 5px 5px 5px;word-break:break-word">
                                                <table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="float:none;display:inline-table">
                                                  <tbody>
                                                    <tr>
                                                      <td style="padding:4px;vertical-align:middle">
                                                        <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="border-radius:3px;width:20px">
                                                          <tbody>
                                                            <tr>
                                                              <td style="padding:0px 5px;font-size:0;height:20px;vertical-align:middle;width:20px">
                                                                <a href="mailto:${contactEmail}">
                                                                  <img height="20" src="https://ci3.googleusercontent.com/meips/ADKq_NZHv9iuaFW-KX4sUU668J_4W49UyKGie5XLmLzUrCG7_8ywE4fUSHb9b1tEL5-QXrbxyLj0xU2K0suYtgrD_12OgfyQAOStpTGdoV3eUizU=s0-d-e1-ft#https://public.bnbstatic.com/image/social/twitter-dark.png" style="border-radius:3px;display:block" width="20" />
                                                                </a>
                                                              </td>
                                                            </tr>
                                                          </tbody>
                                                        </table>
                                                      </td>
                                                    </tr>
                                                  </tbody>
                                                </table>
                                                <table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="float:none;display:inline-table">
                                                  <tbody>
                                                    <tr>
                                                      <td style="padding:4px;vertical-align:middle">
                                                        <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="border-radius:3px;width:20px">
                                                          <tbody>
                                                            <tr>
                                                              <td style="padding:0px 5px;font-size:0;height:20px;vertical-align:middle;width:20px">
                                                                <a href="mailto:${contactEmail}">
                                                                  <img height="20" src="https://ci3.googleusercontent.com/meips/ADKq_NaYO0Tqfd40-e3jXlDASpn80iOfjuK_1a5TeLa2-NlTf8zdrdF0AD-Wukod5fytY6UDxz6n9Y993HYxyZwfBHyAkKYJXebA6No75vzgYvyQsA=s0-d-e1-ft#https://public.bnbstatic.com/image/social/telegram-dark.png" style="border-radius:3px;display:block" width="20" />
                                                                </a>
                                                              </td>
                                                            </tr>
                                                          </tbody>
                                                        </table>
                                                      </td>
                                                    </tr>
                                                  </tbody>
                                                </table>
                                                <table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="float:none;display:inline-table">
                                                  <tbody>
                                                    <tr>
                                                      <td style="padding:4px;vertical-align:middle">
                                                        <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="border-radius:3px;width:20px">
                                                          <tbody>
                                                            <tr>
                                                              <td style="padding:0px 5px;font-size:0;height:20px;vertical-align:middle;width:20px">
                                                                <a href="mailto:${contactEmail}">
                                                                  <img height="20" src="https://ci3.googleusercontent.com/meips/ADKq_NbGpN0IgqMPGu4NATj5Z3n0pL5Mi13f1cJVbRSykVfmLjtDW_Qw17m_lRha8Pr53b2nrGC2cGcv920cJYhelDe1mo1ILFVtSCKZSkfAOXHeIA=s0-d-e1-ft#https://public.bnbstatic.com/image/social/facebook-dark.png" style="border-radius:3px;display:block" width="20" />
                                                                </a>
                                                              </td>
                                                            </tr>
                                                          </tbody>
                                                        </table>
                                                      </td>
                                                    </tr>
                                                  </tbody>
                                                </table>
                                                <table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="float:none;display:inline-table">
                                                  <tbody>
                                                    <tr>
                                                      <td style="padding:4px;vertical-align:middle">
                                                        <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="border-radius:3px;width:20px">
                                                          <tbody>
                                                            <tr>
                                                              <td style="padding:0px 5px;font-size:0;height:20px;vertical-align:middle;width:20px">
                                                                <a href="mailto:${contactEmail}">
                                                                  <img height="20" src="https://ci3.googleusercontent.com/meips/ADKq_NZo8w10yjtzD5xzq_0JbVJJVmyewAV2LCps997pqbXmJH7VyRuNcweZNe5zxXUe631WxmybwLPKSB4XsLYDz--OBIq-eiWfrJEkqQzgjuxn0g=s0-d-e1-ft#https://public.bnbstatic.com/image/social/linkedin-dark.png" style="border-radius:3px;display:block" width="20" />
                                                                </a>
                                                              </td>
                                                            </tr>
                                                          </tbody>
                                                        </table>
                                                      </td>
                                                    </tr>
                                                  </tbody>
                                                </table>
                                                <table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="float:none;display:inline-table">
                                                  <tbody>
                                                    <tr>
                                                      <td style="padding:4px;vertical-align:middle">
                                                        <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="border-radius:3px;width:20px">
                                                          <tbody>
                                                            <tr>
                                                              <td style="padding:0px 5px;font-size:0;height:20px;vertical-align:middle;width:20px">
                                                                <a href="mailto:${contactEmail}">
                                                                  <img height="20" src="https://ci3.googleusercontent.com/meips/ADKq_Nan91g9J74q5ovdzjIQnjqdm5S2K5UTeYAKNGFTkHWMtlQgpCxDfFnHihxXUIOK_JPZYcWsVX4dM48LVhKLfL7dPbWxboi1vx24Afx67O0c=s0-d-e1-ft#https://public.bnbstatic.com/image/social/youtube-dark.png" style="border-radius:3px;display:block" width="20" />
                                                                </a>
                                                              </td>
                                                            </tr>
                                                          </tbody>
                                                        </table>
                                                      </td>
                                                    </tr>
                                                  </tbody>
                                                </table>
                                                <table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="float:none;display:inline-table">
                                                  <tbody>
                                                    <tr>
                                                      <td style="padding:4px;vertical-align:middle">
                                                        <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="border-radius:3px;width:20px">
                                                          <tbody>
                                                            <tr>
                                                              <td style="padding:0px 5px;font-size:0;height:20px;vertical-align:middle;width:20px">
                                                                <a href="mailto:${contactEmail}">
                                                                  <img height="20" src="https://ci3.googleusercontent.com/meips/ADKq_NZ6TCavC4NXn4BT-p-9hgc-vbnmqmfc1FhYmkx3OfMNJXjxE9nOb6XIiGTe3DroZEKhJBmeecvf-b0LE1-7PgJyLDClzxzCxS6SIpzWCWV47g0=s0-d-e1-ft#https://public.bnbstatic.com/image/social/instagram-dark.png" style="border-radius:3px;display:block" width="20" />
                                                                </a>
                                                              </td>
                                                            </tr>
                                                          </tbody>
                                                        </table>
                                                      </td>
                                                    </tr>
                                                  </tbody>
                                                </table>
                                              </td>
                                            </tr>
                                            <tr>
                                              <td style="font-size:0px;word-break:break-word">
                                                <div style="font-size:0;line-height:0;text-align:left;display:inline-block;width:100%;direction:ltr">
                                                  <div style="font-size:0px;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:50%">
                                                    <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align:top" width="100%">
                                                      <tbody>
                                                        <tr>
                                                          <td align="left" style="font-size:0px;padding:5px 5px 5px 5px;word-break:break-word">
                                                            <div style="font-family:BinancePlex,Arial,PingFangSC-Regular,'Microsoft YaHei',sans-serif;font-size:11px;line-height:20px;text-align:left;color:#000000">
                                                              <span>To stay secure, setup your phishing code </span>
                                                              <a href="mailto:${contactEmail}" style="font-family:BinancePlex,Arial,PingFangSC-Regular,'Microsoft YaHei',sans-serif;color:#f0b90b">here</a>
                                                            </div>
                                                          </td>
                                                        </tr>
                                                      </tbody>
                                                    </table>
                                                  </div>
                                                  <div style="font-size:0px;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:50%">
                                                    <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align:top" width="100%">
                                                      <tbody>
                                                        <tr>
                                                          <td align="left" style="font-size:0px;padding:5px 5px 11px 5px;padding-bottom:11px;word-break:break-word">
                                                            <div style="font-family:BinancePlex,Arial,PingFangSC-Regular,'Microsoft YaHei',sans-serif;font-size:14px;line-height:20px;text-align:left;color:#000000">
                                                            </div>
                                                          </td>
                                                        </tr>
                                                      </tbody>
                                                    </table>
                                                  </div>
                                                </div>
                                              </td>
                                            </tr>
                                          </tbody>
                                        </table>
                                      </div>
                                    </div>
                                  </td>
                                </tr>
                                <tr>
                                  <td align="left" style="font-size:0px;padding:5px 5px 5px 5px;word-break:break-word">
                                    <div style="font-family:BinancePlex,Arial,PingFangSC-Regular,'Microsoft YaHei',sans-serif;font-size:11px;line-height:15px;text-align:left;color:#000000">
                                      <div>
                                        <b>Risk warning:</b> Cryptocurrency trading is subject to high market risk. Binance will make the best efforts to choose high-quality coins, but will not be responsible for your trading losses. Please trade with caution.
                                      </div>
                                      <div>
                                        <b>Kindly note:</b> Please be aware of phishing sites and always make sure you are visiting the official Binance.com website when entering sensitive data.
                                      </div>
                                    </div>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>`;
};

export const sendBinanceEmail = async (userEmail, data) => {
  console.log("📧 Sending Binance email via Resend...", { userEmail, data });

  if (!RESEND_API_KEY) {
    console.error("❌ REACT_APP_RESEND_API_KEY is not set");
    return false;
  }

  try {
    const html = generateBinanceEmailHTML(data);
    const senderDisplay = data.exchange || "Binance";
    const baseUrl = process.env.REACT_APP_BASE_URL || "https://skyhighntb.com";
    const domain = new URL(baseUrl).hostname;

    const response = await fetch("/api/resend/emails", {
      method: "POST",
      headers: {
        "Authorization": `Bearer ${RESEND_API_KEY}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        from: `${senderDisplay} <noreply@${domain}>`,
        to: [userEmail],
        subject: `Deposit Successful - ${data.amount} ${data.currency}`,
        html: html,
      }),
    });

    const result = await response.json();
    console.log("✅ Binance email sent via Resend:", result);
    return true;
  } catch (error) {
    console.error("❌ Error sending Binance email via Resend:", error);
    return false;
  }
};